<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12 col-lg-6 c g">
            <div class="card">
                <div class="card-body">
                    <div class="form-group text-right">
                      <h5 for="">JWT Token</h5>
                      <input type="text"
                        class="form-control bg-white form-control-lg" style="direction: ltr" id="text-box" @click="al" v-model="user.jwt" readonly>
                    </div><hr>
                    <h5 dir="ltr" class="text-center">
                        You can find full documanetation <br>at <a href="https://documenter.getpostman.com/view/14352330/2sB3WmT2xp" target="_blank">
                            <img :src="require('@/assets/images/postman.png')" style="height: 30px">
                            from here
                        </a>
                    </h5>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput } from "bootstrap-vue";
export default {
  components: {
    // Layouts
    BModal,BFormInput},
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  data(){
    return {
        user: JSON.parse(localStorage.getItem('user')),
    }
  },
  created(){
    var g = this;
  },
  methods: {
    al(){
        const input = document.getElementById("text-box");
        input.focus();
        input.select();
    }
  }

}
</script>

<style>
.text-right input{
    text-align: right;
}
</style> 